export const screenSize = {
  authenticatedScreenSize: { xs: "100%", md: "588px" }, // for pages before logging in 
  unauthenticatedScreenSize: { xs: "100%", sm: "384px" }, // for pages after logging in for mr Huy, Cong
  carsListScreen: { xs: "100%", md: "768px" }, // for special pages, car list
  headerHeight: { xs: "60px", md: "60px" }, // height for header
  paddingHeader: { xs: "0 16px", md: "0 24px" }, // padding for header 
  backgroundScreenSize: { xs: "calc(100% - 32px)", md: "588px" }, // for header of control center and service tab
};
